import React, { useState } from 'react'
import ShortId from 'shortid'

import RcMentions from 'rc-mentions'

import './index.css'

const { Option } = RcMentions

/**
 *
 * @param {string} value - The current value.
 * @param {Array<object>} options - The options you can mention.
 * @param {string} placeholder - The placeholder for the component.
 * @param {function} onChange - The onChange function.
 * @param {string} className - Class name for the wrapper component.
 * @param {boolean} autoSize - Adjust height based on input.
 *
 * @returns a mentions component
 */
const Mentions = ({
  value,
  options,
  placeholder,
  onChange,
  className,
  autoSize
}) => {
  const [uniqueId] = useState(ShortId.generate())

  return (
    <div className={`width-100 ${className}`}>
      <RcMentions
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoSize={autoSize}
      >
        {options.map((option) => (
          <Option key={`${option.value}-${uniqueId}`} value={option.value}>
            {option.label}
          </Option>
        ))}
      </RcMentions>
    </div>
  )
}

export default Mentions
